import { Component, Input, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: [ './loader.component.scss' ]
})

export class LoaderComponent {

  @Input() visible = false;
  @Input() promise: Subscription;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.visible) {
      if (changes.promise && changes.promise.currentValue) {
        this.visible = true;
        this.promise.add(() => {
          this.visible = false;
        });
      }
    }
  }
}
